<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#chart-line-s"></use></svg>
  Forbrugerpris prognose
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  @if (!hasForecast()) {
    <ok-feedback-fail> Der er ingen prisprognose tilgængelig </ok-feedback-fail>
  } @else {
    <ok-feedback-info> Forbrugerprisen er udregnet for {{ locationAddress }} </ok-feedback-info>
  }

  @if (hasForecast()) {
    <adm-dynamic-price-chart [data]="priceChartData()!" />
  }
</mat-dialog-content>

<mat-dialog-actions>
  <div class="unit-identifier">
    <span>Ladestander - stik-id:</span>
    {{ stationIdentifier }} - {{ connector.connectorId }}
  </div>
  <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Luk</button>
</mat-dialog-actions>
